import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.855 9.148c.098.098.146.226.146.354s-.049.256-.146.354l-3 3a.5003.5003 0 0 1-.707 0v-.002a.5003.5003 0 0 1 0-.707l2.146-2.146H6.001c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h10.293l-2.146-2.146c-.195-.195-.195-.512 0-.707s.512-.195.707 0l3 3zM12 5.5c0 .276-.224.499-.499.499s-.5-.224-.5-.499v-.001L11 5.498V1.1L1 2.918v14.165l10 1.818v-5.402h.001c0-.276.224-.5.5-.5s.5.224.5.5V19.5c0 .148-.066.289-.18.384a.496.496 0 0 1-.32.116.526.526 0 0 1-.089-.008l-11-2a.5013.5013 0 0 1-.411-.492v-15c0-.242.173-.449.411-.492l11-2c.145-.029.296.013.41.108s.18.235.18.384v4.999z',
  ],
  height: 20,
  width: 20,
});
